import { Injectable } from '@angular/core';
import { Observable, Subject, config } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class MediatorService {
  private planObject = null;
  private planObjectReady = new Subject<any>();
  constructor() {
  }

  public getPlanObjectReady(): Observable<any> {
    return this.planObjectReady.asObservable();
  }

  public raiseConfigReadyEvent(planObj) {
    this.planObject = planObj;
    this.planObjectReady.next(planObj);
  }

  getObservable(key, val) {
    // key = 'stageApp';
    return new Observable(observer => {
      if (this.planObject) {
        this.planObject.hasOwnProperty(key) ? observer.next(this.planObject[key] === val) : observer.next(false);
      } else {
        let subscription = this.getPlanObjectReady().subscribe(planObject => {
          if (planObject.hasOwnProperty(key)) {
            observer.next(planObject[key] === val);
          } else {
            observer.next(false);
          }
          subscription.unsubscribe();
          subscription = null;
        });
      }
    });
  }
}
